import { render, staticRenderFns } from "./channelOpe1.vue?vue&type=template&id=cf59088c&scoped=true&"
import script from "./channelOpe1.vue?vue&type=script&lang=js&"
export * from "./channelOpe1.vue?vue&type=script&lang=js&"
import style0 from "./channelOpe1.vue?vue&type=style&index=0&id=cf59088c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf59088c",
  null
  
)

export default component.exports